import { Footer, PageFooterWrapper } from '@signanthealth/modular-ui';

import config from '../../../../package.json';
import { APPLICATION_NAME } from '../../../texts';

export const FooterPage = () => {
  return (
    <PageFooterWrapper data-testid="page-footer-wrapper">
      <Footer appName={APPLICATION_NAME || config.name} appVersion={config.version} />
    </PageFooterWrapper>
  );
};
